import {BaseProps} from '../types'
import {Tab, TabGroup, TabList, TabPanel, TabPanels} from '@headlessui/react'

export default function LibraryTab(props: BaseProps) {

  const renderTabList = () => {
    const tabs = props.dom.querySelectorAll('.tabs > .tab')
    const tabItems = Array.from(tabs)
    return (
      <TabList className={'flex flex-col lg:flex-row justify-center items-center lg:space-x-[375px] mb-[32px] space-y-3 lg:space-y-0'}>
        { tabItems.map((tab: HTMLElement) => {
          return (
            <Tab
              className={'data-[selected]:underline data-[selected]:text-primary outline-none'}
              dangerouslySetInnerHTML={{__html: tab.innerHTML}}
            />
          )
        })}
      </TabList>
    )
  }

  const renderTabPanels = () => {
    const panels = props.dom.querySelectorAll('.panel')
    const items = Array.from(panels)
    return (
      <TabPanels>
        { items.map((item: HTMLElement) => (
          <TabPanel dangerouslySetInnerHTML={{ __html: item.innerHTML }} />
        ))}
      </TabPanels>
    )
  }

  return (
    <TabGroup>
      { renderTabList() }
      { renderTabPanels() }
    </TabGroup>
  )
}